<template>
<div :class="`odr-gap odr-gap_color-${color}
                  ${block === 'true' ? 'odr-gap_block' : ''}
                  odr-gap_left-${eAll || left}
                  odr-gap_right-${eAll || right}
                  odr-gap_top-${eAll || top}
                  odr-gap_bottom-${eAll || bottom}`">
    <slot></slot>
</div>
</template>
<script>
import '../styles/gap.scss'
import { coloringMixin } from '../mixins/coloring'

export default {
    mixins: [coloringMixin],
    props: {
        block: {
            type: String,
            default: 'false',
            _descr: 'Behave like display:block - true, inline-block - false',
        },
        all: {
            type: String,
            default: 'none',
            _descr: 'All margins: half|single|double|none|negative-single|negative-double',
        },
        top: {
            type: String,
            default: 'none',
            _descr: 'Margins on the top: half|single|double|none|negative-single|negative-double',
        },
        bottom: {
            type: String,
            default: 'none',
            _descr: 'Margins on the bottom: half|single|double|none|negative-single|negative-double',
        },
        left: {
            type: String,
            default: 'none',
            _descr: 'Margins on the left: half|single|double|none|negative-single|negative-double',
        },
        right: {
            type: String,
            default: 'none',
            _descr: 'Margins on the right: half|single|double|none|negative-single|negative-double',
        },
    },
    computed: {
        eAll () {
            if (this.all === 'none') {
                return null
            }
            return this.all
        },
    },
}
</script>
